import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Icon } from 'antd';
import { injectIntl } from 'react-intl';
import { fetchResource } from 'ACTIONS/resources.actions';
import './DateReminder.less';

class DateReminder extends Component {
  componentDidMount() {
    this.props.fetchResource('settings');
  }

  render() {
    const { data } = this.props;

    const dateString = data.length
      ? moment(data[0].value, 'YYYY-MM-DD').format('dddd, MMMM DD, YYYY')
      : null;

    return (
      <div className="control-date-reminder">
        <Icon type="calendar" />&nbsp;<b>Next newsletter</b>
        &nbsp;<span className="date-value">{(data.length && data[0].value) ? dateString : 'Loading...'}</span>
      </div>
    );
  }
}

DateReminder.displayName = 'DateReminder';

DateReminder.propTypes = {
  data: PropTypes.array.isRequired,
  // actions
  fetchResource: PropTypes.func.isRequired,
};

const mapStateToProps = ({ resources }) => resources.settings;

const enhanced = compose(
  connect(mapStateToProps, {
    fetchResource,
  }),
  injectIntl,
);

export default enhanced(DateReminder);



// WEBPACK FOOTER //
// ./src/pages/Control/DateReminder/DateReminder.js